import { generateUtilityClass, composeClasses } from '@tino-frontend/coreui'
import { FloatProps } from './float.component'

export interface FloatClass {
  action: string
  children: string
  open: string
  close: string
  paper: string
}

export function getUtilityClass(slot: string): string {
  return generateUtilityClass('TrueFloat', slot)
}

export const useUtilityClasses = (ownerState: FloatProps<'div'>) => {
  const { classes } = ownerState
  const slots = {
    root: ['root'],
    action: ['action'],
    children: ['children'],
    open: ['open'],
    close: ['close'],
    paper: ['paper'],
  }
  const composedClasses = composeClasses(slots, getUtilityClass, classes)
  return {
    ...classes,
    ...composedClasses,
  }
}
